<template>
    <div class="stage">
        <div class="questions-wrapper">
            <div class="questions-block">
                
                <div class="question-block" v-if="isBasePetKt">
                    <div class="question">
                        Який результат попередньої терапії за даними ПЕТ-КТ?
                    </div>
                    <div class="answers">
                        <div class="answer" :class="primaryPetKtResult === 'D4' ? 'active' : ''" @click="primaryPetKtResult = 'D4'">
                            <input type="radio" id="D4" name="primaryPetKtResult" v-model="primaryPetKtResult" value="D4" required>
                            <label for="D4"><strong>D4</strong></label>
                        </div>
                        <div class="answer" :class="primaryPetKtResult === 'D5' ? 'active' : ''" @click="primaryPetKtResult = 'D5'">
                            <input type="radio" id="D5" name="primaryPetKtResult" v-model="primaryPetKtResult" value="D5" required>
                            <label for="D5"><strong>D5</strong></label>
                        </div>
                    </div>
                </div>

                <div class="question-block" v-else>
                    <div class="question">
                        Який результат попередньої терапії за даними КТ?
                    </div>
                    <div class="answers">
                        <div class="answer" :class="primaryKtResult === 'Стабілізація' ? 'active' : ''" @click="primaryKtResult = 'Стабілізація'">
                            <input type="radio" id="D4" name="primaryKtResult" v-model="primaryKtResult" value="Стабілізація" required>
                            <label for="D4"><strong>Стабілізація</strong></label>
                        </div>
                        <div class="answer" :class="primaryKtResult === 'Прогресія' ? 'active' : ''" @click="primaryKtResult = 'Прогресія'">
                            <input type="radio" id="D5" name="primaryKtResult" v-model="primaryKtResult" value="Прогресія" required>
                            <label for="D5"><strong>Прогресія</strong></label>
                        </div>
                    </div>
                </div>

                <error-block />
            </div>
        </div>
    </div>
</template>

<script>
import ErrorBlock from '../../../../../components/Doctor/ErrorBlock';
import { mapMutations, mapGetters } from 'vuex';

export default {
    components : {
        'error-block' : ErrorBlock
    },
    data : () => ({
        primaryPetKtResult : '',
        primaryKtResult : '',
        isBasePetKt : false
    }),
    computed : {
        ...mapGetters([
            'getPrimaryABVDKtResult',
            'getPrimaryPetABVDKtResult',            
            'getIsBasePetKt'
        ])
    },
    methods : {
        ...mapMutations([
            'setPrimaryABVDKtResult',
            'setPrimaryPetABVDKtResult'
        ])
    },
    created(){
        this.isBasePetKt = this.getIsBasePetKt;
        this.primaryKtResult = this.getPrimaryABVDKtResult;
        this.primaryPetKtResult = this.getPrimaryPetABVDKtResult;
    },
    watch : {
        primaryPetKtResult : function(value){
            this.setPrimaryPetABVDKtResult(value);
        },
        primaryKtResult : function(value){
            this.setPrimaryABVDKtResult(value);
        }
    }
}
</script>

<style lang="scss" scoped>
.stage{
    .questions-wrapper{
        width: 360px;
        height: auto;

        .questions-block{
            padding: 20px 40px;

            .question-block{
                .question{
                    font-size: 26px;
                }

                .answers{
                    padding-bottom: 0;

                    .answer{
                        width: 60%;

                        label{
                            font-size: 12px;
                            font-weight: 300;

                            strong{
                                padding-right: 3px;
                                font-size: 14px;
                            }
                        }
                    }

                    .answer:nth-child(2n){
                        margin-left: 0;
                    }
                }
            }           
        }        
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .stage{
        .questions-wrapper{
            width: 35vw;
            height: auto;

            .questions-block{
                padding: 3.125vw 3.333vw;

                .question-block{
                    .question{
                        font-size: 1.667vw;
                    }

                    .answers{
                        .answer{
                            width: 55%;

                            margin-right: 0;

                            label{
                                font-size: 0.95vw;

                                strong{
                                    font-size: 1.042vw;
                                }
                            }
                        }
                    }
                }           
            }
        }
    }
}

@media (max-width: 599px){
    .stage{
        .questions-wrapper{
            width: 100%;

            .questions-block{
                padding: 5.556vw 5.278vw 6.667vw 5.556vw;

                .question-block{
                    .question{
                        font-size: 5.556vw;
                    }
                }
            }
        }
    }
}
</style>